import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import BtnListImgTypeSetting, {
    Design,
} from 'components/property-settings/btn-list-img-type-setting/btn-list-img-type-setting';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';

type PonticDesignProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    ponticDesign: string;
    options?: Design[];
    isRequired?: boolean;
};

const PonticDesign: FC<PonticDesignProps> = ({
    handleSettings,
    ponticDesign,
    options,
    isRequired,
}: PonticDesignProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('PONTIC_DESIGN')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>

            <BtnListImgTypeSetting
                setting={options ? options : CONSTANTS.PONTIC_DESIGN}
                propertyName="ponticDesign"
                settingValue={ponticDesign}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default PonticDesign;
